<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>Justifier les modifications</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="onTerminer()">
      <label for="commentaire" translate>Commentaire</label>
      <textarea type="text" rows="3" id="commentaire" formControlName="commentaire"
                [ngClass]="{'is-invalid': form.submitted && commentaire.invalid}" class="form-control" ></textarea>
      <!-- Boutons d'action -->
      <div class="actions-bar mt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="onAnnuler()" translate>Annuler</button>
        <button type="submit" class="btn btn-primary ml-2" [disabled]="formGroup.invalid" translate>Valider la modification</button>
      </div>
    </form>
  </div>
</div>
